import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, ListItemText, MenuItem, OutlinedInput, Select } from '@mui/material';
import axios from '../util/Axios';
import { useState, useEffect } from 'react';
import { MENU_PROPS } from '../config/constants';

export function AddToDataSet({ testId, handleClose, open }) {
  const [dataSetId, setDataSetId] = useState('');
  const [dataSets, setDataSets] = useState([]);
  
  useEffect(() => {
    axios(`/dataSets?size=2000&sort=name`).then((response) => {
      setDataSets(response.data.content);
    });
  }, []);

  const label = 'Select Data Set';

  function handleChange(event) {
    const {
      target: { value },
    } = event;
    setDataSetId(value);
  }

  function handleAdd() {
    axios(`dataSets/${dataSetId}/${testId}`, {
      method: 'PUT',
    }).then((resp) => handleClose());
  }

  return (
    <>
      <Dialog open={open}>
        <DialogTitle>Add to Data Set</DialogTitle>
        <DialogContent>
          <FormControl sx={{ m: 1, width: 300 }} size="small">
            <InputLabel id="filter_label">{label}</InputLabel>
            <Select labelId="filter_label" value={dataSetId} onChange={handleChange} input={<OutlinedInput label={label} />} MenuProps={MENU_PROPS}>
              {dataSets.map((dataSet) => (
                <MenuItem key={dataSet.uuid} value={dataSet.uuid}>
                  <ListItemText primary={dataSet.name} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button variant="contained" onClick={handleAdd}>
            Add
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
